import React from "react";
import { makeStyles } from "tss-react/mui";
import { Typography, Box, Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const useStyles = makeStyles()((theme) => ({
  banner: {
    backgroundColor: "#4CAF50", // Green background for promotion
    color: "white",
    padding: "12px 20px",
    textAlign: "center",
    position: "relative",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  bannerShift: {
    width: `calc(100% - 360px)`, // 360px is the drawer width from postGenerator
    marginLeft: 360,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  bannerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "16px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  bannerText: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  promoCode: {
    backgroundColor: "rgba(255,255,255,0.2)",
    padding: "4px 12px",
    borderRadius: "4px",
    fontFamily: "monospace",
    fontWeight: "bold",
    fontSize: "16px",
    border: "1px solid rgba(255,255,255,0.3)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "3px 8px",
    },
  },
  ctaButton: {
    backgroundColor: "white",
    color: "#4CAF50",
    fontWeight: "bold",
    textTransform: "none",
    padding: "6px 16px",
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.9)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "4px 12px",
    },
  },
  mobileStack: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "8px",
    },
  },
}));

function LaunchBanner() {
  const { classes } = useStyles();
  const location = useLocation();

  // Only show banner on the pricing page
  if (location.pathname !== "/pricing") {
    return null;
  }

  return (
    <Box className={classes.banner}>
      <div className={`${classes.bannerContent} ${classes.mobileStack}`}>
        <Typography className={classes.bannerText}>
          🚀 Launch Special: Get 25% off all plans with code
        </Typography>
        <span className={classes.promoCode}>LAUNCH25</span>
        <Button
          component={Link}
          to="/pricing"
          className={classes.ctaButton}
          size="small"
        >
          Get Started
        </Button>
      </div>
    </Box>
  );
}

export default LaunchBanner;
